import * as yup from 'yup';
import { InputType, ProgramLevelQuestionType } from 'redux/schemas/models/mentoring-program-profile-questions';
import { CONCURRENT_MENTOR_CONNECTION_ID, AccountField } from 'athena/components/mentoring-program/constants';
import t from 'react-translate';

export const getQuestionSchema = (
  isRequired: boolean,
  type: InputType | ProgramLevelQuestionType,
) => {
  let answerSchema: yup.AnySchema;

  switch (type) {
    case InputType.CHECKLIST:
    case ProgramLevelQuestionType.CHECKLIST:
      answerSchema = yup.array().of(yup.string()).nullable();
      if (isRequired) {
        answerSchema = (answerSchema as yup.ArraySchema<string>).min(1).required();
      }
      break;
    case InputType.IMAGE:
      answerSchema = yup.mixed();
      if (isRequired) {
        answerSchema = answerSchema.required();
      }
      break;
    default:
      answerSchema = yup.string().nullable();
      if (isRequired) {
        answerSchema = answerSchema.required().test(
          'not-empty',
          t.FORM.REQUIRED(),
          (value) => {
            if (typeof value === 'string') {
              return value.trim().length > 0;
            }
            return !!value;
          },
        );
      }
      break;
  }

  return yup.object().shape({
    answer: answerSchema,
  });
};

type DynamicSchemaOptions = {
  hasBasicInfoEdit: boolean;
  isMentor: boolean;
  mentorCapacityEnabled: boolean;
};

export const createDynamicSchema = (
  questions: any[],
  options: DynamicSchemaOptions,
) => {
  const { hasBasicInfoEdit, isMentor, mentorCapacityEnabled } = options;
  const shape: any = {};

  if (hasBasicInfoEdit) {
    shape.firstName = yup.string().required().trim();
    shape.lastName = yup.string().required().trim();
  }

  if (isMentor && mentorCapacityEnabled) {
    shape[CONCURRENT_MENTOR_CONNECTION_ID] = getQuestionSchema(true, ProgramLevelQuestionType.DROPDOWN);
  }

  questions.forEach((q) => {
    let type: InputType | ProgramLevelQuestionType;
    const { isRequired } = q;

    if (q.profileQuestion?.questionList) {
      ({ type } = q.profileQuestion.questionList);
    } else if (q.profileQuestion?.profileSetting) {
      type = q.profileQuestion.profileSetting.inputType;
    } else if (q.novoedQuestionName === AccountField.PICTURE_FILE_NAME) {
      type = InputType.IMAGE;
    } else {
      type = q.type || InputType.SHORT_TEXT;
    }
    shape[q.id.toString()] = getQuestionSchema(isRequired, type);
  });

  return yup.object().shape(shape);
};
